import { FeathersModel } from './feathersModel'

export class CareType extends FeathersModel {
  static serviceName = 'care-types'

  socialServiceTypeId: number
  name: string
  createdAt?: string
  updatedAt?: string
}
